import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Config861EditService {

  constructor(private http: HttpClient) { }

  saveConfig861(
    baseUrl: string,
    clobDataDetails: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build settings object
    const clobSettingsObj = {
      sso_id: clobDataDetails[0]?.sso_id,
      scenario: clobDataDetails[0]?.scenario,
      jcd_key: globalService?.jcd_key
    };

    // Build parameters EXACTLY like AngularJS
    // Start with filterParams
    let params = filterParams || {};
    
    // Merge _data[0] (first element of clobDataDetails) into params - CRITICAL!
    params = _.merge({}, clobDataDetails[0] || {}, params);
    
    // Merge globalService.globalParams
    params = _.merge({}, globalService || {}, params);
    
    // Add clob_data and clob_settings - MUST be after merges
    params.clob_data = JSON.stringify(clobDataDetails);
    params.clob_settings = JSON.stringify(clobSettingsObj);
    
    // Add params that exist in AngularJS payload
    if (!params.scenarioCode) {
      params.scenarioCode = filterParams.scenarioCode || filterParams.scenario_code || "RAF";
    }
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = "N";
    }
    
    // Ensure these fields exist (they're in AngularJS payload)
    if (!params.issue_id) params.issue_id = "";
    if (!params.issue_short_desc) params.issue_short_desc = "";
    if (!params.issue_id_for_tx_save) params.issue_id_for_tx_save = "";

    // checkLockedbj should be simpler like in AngularJS
    const checkLockedbj = [{
      "scenario_key": parseInt(filterParams.scenario) || params.scenario || 74
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    console.log('=== DEBUG SERVICE PARAMS ===');
    console.log('Final params before URLSearchParams:', params);
    console.log('clobDataDetails:', clobDataDetails);
    console.log('clobSettingsObj:', clobSettingsObj);

    const url = `${baseUrl}/saveJsonObject?action_code=iqec76`;

    // Convert to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  getCodeMasterData(
    baseUrl: string,
    requestParams: any,
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    
    // Build parameters
    let params = _.merge({}, globalService || {}, filterParams, requestParams);
    
    const url = `${baseUrl}/loadJsonObject`;

    // Convert to URLSearchParams for application/x-www-form-urlencoded
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}
